import React from 'react';
import { CheckIcon } from 'lucide-react';
import { OfferPanel } from '../OfferPanel';
import { finalImagine } from '../../data/content';
export function FinalCTA() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-140" data-mp="3mts3gligb187">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-2 lg:items-center lg:gap-16" data-id="element-141" data-mp="3mt8rrmje992m">
        <div data-id="element-142" data-mp="3rrab88kqfaem">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-electric sm:text-sm" data-id="element-143" data-mp="3rr0mspfc5bb1">
            Your next orthodontic case deserves a clearer plan
          </p>
          <h2 className="text-balance mt-3 font-display text-[36px] font-black leading-[1.02] tracking-tight text-white sm:text-6xl" data-id="element-144" data-mp="3hvgqw30rucma">
            Stop Guessing Your <span className="text-electric" data-id="element-145" data-mp="38tzf2wuecx3e">Torque Mechanics.</span>
          </h2>
          <p className="mt-5 text-lg font-semibold text-white/90" data-id="element-146" data-mp="38vtzma1ran6y">
            Start building more structured root-movement plans with the 15-Minute Torque Planning Framework™.
          </p>
          <p className="mt-6 text-white/75" data-id="element-147" data-mp="170jlbr30j247">Imagine reviewing your next orthodontic case with a clearer understanding of:</p>
          <ul className="mt-4 space-y-3" data-id="element-148" data-mp="l9k5jbjs7hv8">
            {finalImagine.map(item => <li key={item} className="flex gap-3 font-medium text-white" data-id="element-149" data-mp="l7pq2cra4hyj">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-150" data-mp="z05m2tlrjfpy">
                  <CheckIcon className="h-3.5 w-3.5 text-ink" aria-hidden="true" data-id="element-151" data-mp="v1gan6kac88y" />
                </span>
                {item}
              </li>)}
          </ul>
          <p className="mt-6 text-white/75" data-id="element-152" data-mp="2c93jj6rmac3">
            That’s the purpose of <strong className="text-white" data-id="element-153" data-mp="gapl65661l90">Orthodontic Torque Control Blueprint™</strong>. Six
            specialized clinical volumes. Five exclusive bonuses. One structured educational framework.
          </p>
        </div>
        <div data-id="element-154" data-mp="1rob77hgqb6qb">
          <p className="mb-4 text-center font-display text-xl font-extrabold uppercase text-white" data-id="element-155" data-mp="1rnrr86an2sex">
            All for a one-time payment of <span className="text-cta" data-id="element-156" data-mp="kd3qq7uy6igr">just $27 USD</span>
          </p>
          <OfferPanel ctaLabel="Yes! I want the Orthodontic Torque Control Blueprint™" data-id="element-157" data-mp="kcu2aopjwjd6" />
        </div>
      </div>
    </section>;
}